export class OpdModel {
    id?: number;
    kodeOpd?: string;
    namaOpd?: string;
    kodeNamaOpd?: string;
    kodeWilSp2dProses?: string;
    kodeWilSpdProses?: string;
    idOpd?: string;
}